module.exports = __webpack_public_path__ + "img/高投入.bc7df2e3.png";